export default "__VITE_ASSET__NVIxuI87__"